import { API } from 'aws-amplify';
import { Medication } from './query';


export const PATIENT = "patient";
export const MAR = "mar";
export const ENCOUNTERS = "encounters";
export const REASONS_FOR_VISIT = "reasons_for_visit";
export const ACTIVE_CSN_BY_PATIENT_FHIR_ID = "active_csn_by_patient_fhir_id";

export interface FetchFhirPatientInput {
    mrn: string,
}

export interface FetchFhirMedicationsInput {
    csn: string,
    mrn: string,
    external_id: string,
}

export interface FetchFhirEncountersInput {
    fhir_id: string,
    from_date: string,
    to_date: string,
}

export interface FetchFhirReasonsForVisitInput {
    fhir_id: string,
    csn: string,
}

export interface FetchFhirActiveCsnForPatientFhirID {
    fhir_id: string,
}

export interface FhirPatientVisit {
    mrn: string,
    family: string | null,
    given: string | null,
    email: string | null,
    phone_home: string | null,
    phone_mobile: string | null,
    languages: string[] | null,
}


export const callFhirMedications = async (input: FetchFhirMedicationsInput): Promise<Medication[]> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/fetch-sync-fhir', {
            body: {
                ...input,
                operation: MAR,
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });
        console.log('callFetchSyncFhir response', JSON.parse(response.response));
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while fetching medications", err);
        return [];
    }
}

export const callFhirPatient = async (input: FetchFhirPatientInput): Promise<FhirPatientVisit> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/fetch-sync-fhir', {
            body: {
                ...input,
                operation: PATIENT,
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return {
            mrn: input.mrn,
            family: "",
            given: "",
            email: "",
            phone_mobile: "",
            phone_home: "",
            languages: [],
        };
    }
}

export const callFhirEncounters = async (input: FetchFhirEncountersInput): Promise<any> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/fetch-sync-fhir', {
            body: {
                ...input,
                operation: ENCOUNTERS,
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return [];
    }
}

export const callFhirReasonsForVisit = async (input: FetchFhirReasonsForVisitInput): Promise<any> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/fetch-sync-fhir', {
            body: {
                ...input,
                operation: REASONS_FOR_VISIT,
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return [];
    }
}

export const callFhirActiveCsnByPatientFhirID = async (input: FetchFhirActiveCsnForPatientFhirID): Promise<any> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/fetch-sync-fhir', {
            body: {
                ...input,
                operation: ACTIVE_CSN_BY_PATIENT_FHIR_ID,
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return JSON.parse(response.response);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return "";
    }
}
